<template>
  <i-badge :count="count" :offset="[-10, 118]" class-name="badge-alone" size="large">
    <div class="home-work-item" :style="{ background: bcolor }">
      <div class="title-box">
        <img :src="icon" />
        <span class="title">{{ title }}</span>
        <span class="desc">{{ desc }}</span>
      </div>
    </div>
  </i-badge>
</template>

<script>
export default {
  props: ['title', 'count', 'icon', 'desc', 'bcolor'],
};
</script>

<style lang="less" scoped>
@import '../../assets/fonts/font.less';
@import '../../assets/css/main.less';
.home-work-item {
  width: 240px;
  height: 256px;
  border-radius: 10px;
  background: rgba(255, 191, 163, 0.12);
  padding: 24px;
  background: #ffffff;
  box-shadow: 0 0 10px 0 #eeeff0;
  .title-box {
    display: flex;
    flex-direction: column;
    padding-top: 38px;
    align-items: center;
    img {
      width: 32px;
      height: 32px;
    }
    .title {
      .font-bold;
      font-size: 24px;
      font-weight: 400;
      line-height: 29px;
      margin: 16px 0 12px 0;
    }
    .desc {
      .font-light;
      font-size: 14px;
      font-weight: 300;
      color: @app-body-color;
      line-height: 20px;
      text-align: center;
    }
  }
}
</style>
<style lang="less">
@import '../../assets/fonts/font.less';

.badge-alone {
  .font-din-cond;
  background: #5BC0D7 !important;
  font-size: 22px;
  width: 40px;
  height: 40px;
  line-height: 39px;
  border-radius: 50px;
  font-weight: 900;
  z-index: auto;
}
</style>
